// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1Gs-7","text":"SelectPayment_text__10t2Q","title":"SelectPayment_title__3r12I","btn":"SelectPayment_btn__3WXIh"};